export default () => 0.5 - Math.random();



// WEBPACK FOOTER //
// /src/js/common/utils/bookmakersSorting.js